import React,{useState,useEffect,useRef} from 'react'
import { Link, useParams } from 'react-router-dom'
import { useAuthAxios } from './authfetch'
import { apiurl, staticurl } from '../common/constants'
import ItemCard from './ItemCard'
import Footer from './Footer'
import { CategoryWithSubCategorySelect } from './subcomponents/Selectors'
import BrandList from './subcomponents/BrandsList'
import { useStore } from '../context/StoreContext'
import Pagination from './subcomponents/Pagination'
import './IndividualBrandDesc.css'

const BrandContent = ({ brandName }) => {
  const [brand,setBrand] = useState(null)
  const [brandProduct,setBrandProduct] = useState(null)
  const [fetchedBrandproduct,setfetchedBrandproduct] = useState(null)
  const [pageCount,setPageCount] = useState(1)
  const authAxios = useAuthAxios();
  const [brandRelatedDistinctCategory,setBrandRelatedDistinctCategory] = useState(null)
  const {setIsLoading} = useStore();
  const [selectedBrandCategory,setSelectedBrandCategory] = useState(null)
  const productPerPage = 24;
  
  const handlepageclick = (newCount) =>{
    if (newCount > 0 && newCount <=Math.ceil(brandProduct.data.totalCount / productPerPage) ){
      setPageCount(newCount)

    }
  }
  
  useEffect(() => {
    const fetchBrand = async () => {
      setIsLoading(true);
      try {
        const { data } = await authAxios.get(`${apiurl}/brands/get/${brandName}`);
        setBrand(data.data)
      } catch (err) {
        console.log(err)
      } finally {
        setIsLoading(false)
      }
    };
    fetchBrand();
  }, [brandName])
  
  useEffect(() => {
    let active = true; 
    const fetchBrandProducts = async () => {
      if (brand) {
        // get brand categories
        try {
          if(active) setIsLoading(true);
          const { data: categoryData } = await authAxios.post(apiurl + "/search/getdistinctcategory", {
            brand_ref: brand._id
          });
          if(active) setBrandRelatedDistinctCategory(categoryData)
        } catch (err) {
          console.log(err);
          if(active) setIsLoading(false);
        }
        
        // get brand products
        try {
          if(active) setIsLoading(true);
          const { data: productData } = await authAxios.post(`${apiurl}/brands/getbrandproduct`, {
            _id: brand._id,
            pageNumber: pageCount,
            productPerPage,
            category_ref: selectedBrandCategory,
          });
          if(active) setfetchedBrandproduct(productData)
        } catch (err) {
          if(active) {
            setIsLoading(false);
            console.log(err)
          }
        } finally {
          if(active) setIsLoading(false);
        }
      }
    };
    fetchBrandProducts();
    return () => { active = false; };
  }, [brand, pageCount, selectedBrandCategory]);

  useEffect(() => {
    setBrandProduct(fetchedBrandproduct)
  }, [fetchedBrandproduct])

  const handleDistinctCategoryChange = (val) =>{
    // set catagory to send through /brands/getbrandproduct
    setSelectedBrandCategory(val)
    setPageCount(1)
    
  }

  return (
    <>
    <div className="brand-page">
      {/* Brands Carousel Section */}
      <section className="brands-carousel-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title brand-section-heading">Brands</h2>
            <Link to="/brands" className="view-all-link">
              View All
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
          <div className='brandLogoWrapper'>
            <div className='cont'>
              <BrandList />
            </div>
          </div>
        </div>
      </section>

      {brand && (
        <>
          {/* Brand Hero Section */}
          <section className="brand-hero">
            <div className="container">
              <div className="brand-hero-content">
                <div className="brand-logo-wrapper">
                  <img src={staticurl + brand.brandLogo} alt={brand.brandName} />
                </div>
                <div className="brand-info">
                  <h1 className="brand-title ">{brand.brandName}</h1>
                  <p className="brand-description">{brand.brandDesc}</p>
                </div>
              </div>
            </div>
          </section>

          {/* Products Section */}
          <section className="brand-products-section">
            <div className="container">
              {/* Filter Bar */}
              <div className="filter-bar">
                <div className="filter-bar-left">
                  <h3 className="products-title">
                    Products from {brand.brandName}
                    {brandProduct && (
                      <span className="product-count">
                        ({brandProduct.data.totalCount} products)
                      </span>
                    )}
                  </h3>
                </div>
                <div className="filter-bar-right">
                  <div className="filter-select-wrapper">
                    <CategoryWithSubCategorySelect 
                      firstOption="All Categories" 
                      selectId="invididualbrand-categorySelect" 
                      categories={brandRelatedDistinctCategory} 
                      onChange={handleDistinctCategoryChange}
                      value={selectedBrandCategory || ""}
                    />
                  </div>
                </div>
              </div>

              {/* Products Grid */}
              <div className="products-grid">
                {brandProduct && brandProduct.data.products.map(elem => (
                  <div className="product-item" key={elem._id}>
                    <ItemCard img={elem}/>
                  </div>
                ))}
              </div>

              {/* Empty State */}
              {brandProduct && brandProduct.data.products.length === 0 && (
                <div className="empty-state">
                  <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <circle cx="11" cy="11" r="8"/>
                    <path d="m21 21-4.35-4.35"/>
                  </svg>
                  <h4>No products found</h4>
                  <p>Try selecting a different Brand</p>
                </div>
              )}

              {/* Pagination */}
              <Pagination
                currentPage={pageCount}
                totalPages={brandProduct ? Math.ceil(brandProduct.data.totalCount / productPerPage) : 1}
                onPageChange={handlepageclick}
              />
            </div>
          </section>
        </>
      )}
    </div>
    <Footer />
    </>
  )
}

export default function IndividualBrandDesc() {
  const { brandname } = useParams()
  return <BrandContent key={brandname} brandName={brandname} />
}
